import React, { FunctionComponent, ReactElement, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import BodyFont from '../../Theme/Fonts/Body'
import { getFontColorByBackgroundColor } from '../../utils/Colors'
import { TestID } from '../../utils/PropTypesDefinitions'

export type TagProps = {
    /**
     * Text to be displayed
     * */
    children: string
    /**
     * Sets the background color
     * */
    backgroundColor: 'onyx' | 'pearl'
    /**
     * function to be called when pressed
     *
     * @TJS-type function
     * */
    onPress?: () => void
} & TestID

const Tag: FunctionComponent<TagProps> = ({
    children,
    backgroundColor,
    onPress,
    testID,
}): ReactElement => {
    return (
        <Grid horizontal noExpand testID={testID}>
            <Touchable onPress={onPress}>
                <Grid
                    backgroundColor={backgroundColor}
                    paddingX={3}
                    paddingY={2}
                    borderRadius={3}
                    elevation={backgroundColor !== 'onyx' ? 3 : 0}
                    noExpand
                >
                    <BodyFont color={getFontColorByBackgroundColor(backgroundColor)}>
                        {children}
                    </BodyFont>
                </Grid>
            </Touchable>
        </Grid>
    )
}

export default memo(Tag)
